<template>
  <div>

    <header class="menu">
      <section class="top">
      <a href="./"><img src="/static/img/app/logo_gorsh.svg?v=1.0" class="logo" /></a>

      <div class="anchors text-right">

        <ul class="list-inline" >
          <li class="dropdown hidden-xs hidden-sm">

            <a class="dropdown-toggle" data-toggle="dropdown" href="#"
               role="button" aria-haspopup="true" aria-expanded="false">{{user.email}} &nbsp; <i class="fa fa-angle-down"></i>
            </a>

            <div class="dropdown-menu dropdown-menu-right">
              <router-link class="dropdown-item" to="/myorders">Mis Compras</router-link>


              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="#" @click.prevent="logout">Salir</a>
            </div>

          </li>

        </ul>



      </div>

    </section>

    </header>

    <div class="compensate-header"></div>

  </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {
        data(){
          return {
            categories:[]
          }
        },
        computed: {
          ...mapGetters(['user','isLogged','cart_total','cart_items'])
        },
        methods:{
          logout(){
            this.$store.dispatch('logout', this)
              .then(() => {
                this.$router.push({name: 'Login'});
              })
              .catch(err => {

              });
          }
        },
        mounted(){

        }
    }
</script>

<style scoped>
    .compensate-header{
        height: 60px;
    }
</style>



// WEBPACK FOOTER //
// src/components/HeaderCheckoutPartial.vue